export const organizationsPage = () =>
  import("./OrganizationsPage").then((m) => ({ Component: m.OrganizationsPage }));
